import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class DataTransferService {
    public Data: any;
    public NewAddedWidgetId: number = undefined;
    public ExportedDashboardData: any;    
}
